// Dicionário de aliases conforme item 9.8 do Funcional.txt e cobertura total dos nomes_tema do banco
export const layerAliases = {
  APP: [
    'APP segundo art. 61-A da Lei n 12.651/2012',
    'APP Total',
    'Area de Preservacao Permanente a Recompor de Lagos e Lagoas Naturais',
    "Area de Preservacao Permanente a Recompor de Nascentes ou Olhos D'agua Perenes",
    'Area de Preservacao Permanente a Recompor de Rios ate 10 metros',
    'Area de Preservacao Permanente a Recompor de Rios com mais de 600 metros',
    'Area de Preservacao Permanente a Recompor de Rios de 10 ate 50 metros',
    'Area de Preservacao Permanente a Recompor de Rios de 200 ate 600 metros',
    'Area de Preservacao Permanente a Recompor de Rios de 50 ate 200 metros',
    'Area de Preservacao Permanente a Recompor de Veredas',
    'Area de Preservacao Permanente de Areas com Altitude Superior a 1800 metros',
    'Area de Preservacao Permanente de Areas com Declividades Superiores a 45 graus',
    'Area de Preservacao Permanente de Banhado',
    'Area de Preservacao Permanente de Bordas de Chapada',
    'Area de Preservacao Permanente de Lagos e Lagoas Naturais',
    'Area de Preservacao Permanente de Manguezais',
    "Area de Preservacao Permanente de Nascentes ou Olhos D'agua Perenes",
    'Area de Preservacao Permanente de Reservatorio artificial decorrente de barramento de cursos dagua',
    'Area de Preservacao Permanente de Restingas',
    'Area de Preservacao Permanente de Rios ate 10 metros',
    'Area de Preservacao Permanente de Rios com mais de 600 metros',
    'Area de Preservacao Permanente de Rios de 10 ate 50 metros',
    'Area de Preservacao Permanente de Rios de 200 ate 600 metros',
    'Area de Preservacao Permanente de Rios de 50 ate 200 metros',
    'Area de Preservacao Permanente de Topos de Morro',
    'Area de Preservacao Permanente de Veredas',
    'Area de Preservacao Permanente em area antropizada nao declarada como area consolidada',
    'Area de Preservacao Permanente em area consolidada',
    'Area de Preservacao Permanente em area de Vegetacao Nativa',
    'Banhado',
    'Entorno de Reservatorio para Abastecimento ou Geracao de Energia',
    'Manguezal',
    'Restinga',
    'Vereda',
  ],
  'USO RESTRITO': [
    'Area com altitude superior a 1.800 metros',
    'Area de declividade maior que 45 graus',
    'Area de topo de morro',
    'Area de Uso Restrito para declividade de 25 a 45 graus',
    'Area de Uso Restrito para regioes pantaneiras',
    'Borda de chapada',
  ],
  'ÁREA CONSOLIDADA': ['Area Consolidada'],
  'ÁREA DE POUSIO': ['Area de Pousio'],
  'ÁREA DE SERVIDÃO': [
    'Area de Servidao Administrativa Total',
    'Infraestrutura Publica',
    'Utilidade Publica',
  ],
  'ÁREA DO IMÓVEL': ['Area do Imovel'],
  'VEGETAÇÃO NATIVA': ['Remanescente de Vegetacao Nativa'],
  'RESERVA LEGAL': [
    'Reserva Legal Aprovada e nao Averbada',
    'Reserva Legal Averbada',
    'Reserva Legal Proposta',
  ],
  HIDROGRAFIA: [
    "Curso d'agua natural acima de 600 metros",
    "Curso d'agua natural de 10 a 50 metros",
    "Curso d'agua natural de 200 a 600 metros",
    "Curso d'agua natural de 50 a 200 metros",
    "Curso d'agua natural de ate 10 metros",
    'Lago ou lagoa natural',
    "Reservatorio artificial decorrente de barramento ou represamento de cursos d'agua naturais",
    'Reservatorio para Abastecimento ou Geracao de Energia',
  ],
};

// Função utilitária para normalizar nomes (remove acentos, caixa baixa)
export function normalize(str) {
  return (
    str
      .normalize('NFD')
      // eslint-disable-next-line no-control-regex
      .replace(/[\u0000-\u007f]/g, (c) => c)
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, ' ')
      .trim()
  );
}

export function getAliasFromNomeTema(nome) {
  const nomeNorm = normalize(nome);
  for (const [alias, nomes] of Object.entries(layerAliases)) {
    if (nomes.some((n) => normalize(n) === nomeNorm)) return alias;
  }
  return nome;
}
